// AUTOGENERATED: DO NOT EDIT

import { AnimatedSprite, Spritesheet, SpritesheetData, Texture } from "pixi.js";
import img from "../../assets/img/fish/tinyfish-1.png";
import { SpriteSheetJSON } from "./type";

const data: SpriteSheetJSON = {
  frames: {
    "Sprite-0003 0.": {
      frame: {
        x: 0,
        y: 0,
        w: 16,
        h: 16,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 16,
        h: 16,
      },
      sourceSize: {
        w: 16,
        h: 16,
      },
      duration: 100,
    },
    "Sprite-0003 1.": {
      frame: {
        x: 16,
        y: 0,
        w: 16,
        h: 16,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 16,
        h: 16,
      },
      sourceSize: {
        w: 16,
        h: 16,
      },
      duration: 100,
    },
    "Sprite-0003 2.": {
      frame: {
        x: 32,
        y: 0,
        w: 16,
        h: 16,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 16,
        h: 16,
      },
      sourceSize: {
        w: 16,
        h: 16,
      },
      duration: 100,
    },
    "Sprite-0003 3.": {
      frame: {
        x: 48,
        y: 0,
        w: 16,
        h: 16,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 16,
        h: 16,
      },
      sourceSize: {
        w: 16,
        h: 16,
      },
      duration: 100,
    },
  },
  meta: {
    app: "https://www.aseprite.org/",
    version: "1.3.9.2-arm64",
    image: "tinyfish-1.png",
    format: "RGBA8888",
    size: {
      w: 64,
      h: 16,
    },
    scale: "1",
    frameTags: [],
    layers: [
      {
        name: "Layer 1",
        opacity: 255,
        blendMode: "normal",
      },
    ],
    slices: [],
  },
  animations: {
    swim: [
      "Sprite-0003 0.",
      "Sprite-0003 1.",
      "Sprite-0003 2.",
      "Sprite-0003 3.",
    ],
  },
};
export const tinyfish1 = async () => {
  const texture = Texture.from(img);
  texture.source.scaleMode = "nearest";

  const spritesheet = new Spritesheet(texture, data as SpritesheetData);

  await spritesheet.parse();

  const swim = new AnimatedSprite(spritesheet.animations.swim);

  swim.width = 32;
  swim.height = 32;
  swim.anchor.set(0.5, 0.5);

  return swim;
};
